<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/ibank/ibankAccount")
          i.fas.fa-money-bill-alt
          span.ml-1 {{ $t("ui.ibank_account") }}
      b-breadcrumb-item(v-if="currOperator && pageLvl != 'opr' && getAccountType == 3")
        i.fa.fa-user
        span.ml-1 {{ currOperator.account_id }}
  div.row
    div.col-md-12
      div.card
        div.card-header(v-if="getAccountType == 3 && pageLvl == 'opr'")
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getOperatorList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.mb-1(v-if="pageLvl == 'opr'")
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalOprRow"
                  :per-page="getPageSize"
                  v-model="currentOprPage"
                  @input="changedOprPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedOprPageSize")
          div.row.clusterize
            div.col-md-12(v-if="pageLvl=='opr'")
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('profile_id')")
                        span(:title="$t('ui.profile_id')") {{ $t('ui.profile_id') }}
                        i(:class="changeSortKey('profile_id')")
                      th.sticky-position.sortable(width="23%" @click="sortOrder('full_name')")
                        span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                        i(:class="changeSortKey('full_name')")
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                      th.sticky-position.sortable(width="7%" @click="sortOrder('status')")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        i(:class="changeSortKey('status')")
                      th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_date')")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date')")
                  tbody.clusterize-content
                    tr(v-if="filteredOperatorList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredOperatorList" :class="$helpers.rowClass(item)")
                      td
                        span(:title="((currentOprPage - 1) * getPageSize + index + 1)") {{ ((currentOprPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="setOperatorAccId(item, true)") {{ item.account_id }}
                      td
                        span(:title="item.profile_id") {{ item.profile_id }}
                      td
                        span(:title="item.full_name") {{ item.full_name }}
                      td
                        span(:title="item.contact_phone") {{ item.contact_phone }}
                      td
                        span(:title="item.last_login_ip") {{ item.last_login_ip }}
                      td
                        span(:title="item.status") {{ item.status }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
            div.col-md-12(v-if="currOperator && pageLvl=='bankAcc'")
              div.mb-1(v-if="getAccountType == 3")
                SubmitButton(
                  :loading="loading"
                  icon="icon-arrow-left"
                  :text="$t('ui.back')"
                  type="button"
                  @click="backToOperatorLvl"
                  variant="secondary"
                  size="sm"
                  ).mb-1.mr-1
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position(width="6%")
                        span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                      th.sticky-position(width="20%")
                        span(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
                      th.sticky-position(width="12%")
                        span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      th.sticky-position(width="20%")
                        span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.type')") {{ $t("ui.type") }}
                      th.sticky-position.text-center(width="7%")
                        span(:title="$t('ui.provider_status')") {{ $t("ui.short.provider_status") }}
                      th.sticky-position.text-center.sticky-toggle(width="7%")
                        span(:title="$t('ui.own_status')") {{ $t("ui.short.own_status") }}
                      th.text-center.sticky-position(width="6%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                      th.text-right.sticky-position(width="10%")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  tbody.clusterize-content
                    tr(v-if="ibankAccountList.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in ibankAccountList" :class="$helpers.rowClassBit(item.own_status)")
                      td
                        span(:title="index + 1") {{ index + 1 }}
                      td
                        span(:title="item.bank_id") {{ item.bank_id }}
                      td
                        span(:title="item.bank_name") {{ item.bank_name }}
                      td
                        span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                      td
                        span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
                      td
                        span(:title="item.bank_acc_type") {{ item.bank_acc_type }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.provider_status == true || item.provider_status == null, 'fas fa-times text-warning': !item.provider_status  }")
                      td
                        div.d-flex.justify-content-center.align-items-center(v-if="item.bank_acc_no")
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="item.own_status" @change="changediBankAccStatus(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                      td.actions
                        span(v-if="item.provider_status != false")
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                      td.text-right
                        span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    editibankaccount(ref="editibankaccount" @clicked="afterEditiBankAccount" :item="editSelectediBankAccount" :opr="currOperator" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editibankaccount from "@/components/ibank/editiBankAccount.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editibankaccount,
  },
  data: () => ({
    loading: false,
    operatorList: [],
    ibankAccountList: [],
    currentOprPage: 1,
    totalOprRow: 0,
    search: "",
    sortKey: "account_id",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pageLvl: 'opr',
    editSelectediBankAccount: null,
    currOperator: null
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredOperatorList() {
      return this.operatorList.filter(function(obj) {
        return obj.self_operate == false;
      })
    },
    getAccountType() {
      if (this.$store.getters.account[0])
        return this.$store.getters.account[0].account_type;

      return 0;
    },
  },
  mounted: function() {
    if(this.$store.getters.account[0]) {
      if (this.$store.getters.account[0].account_type == 2) {
        this.currOperator = this.$store.getters.account[0];
        this.pageLvl = 'bankAcc';
        this.getiBankAccList();
      } else if (this.$store.getters.account[0].account_type == 3) {
        this.getOperatorList(true);
      }
    }
  },
  methods: {
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getOperatorList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    backToOperatorLvl() {
      this.pageLvl = "opr";
      this.search = "";
      this.ibankAccountList = [];
      this.currOperator = null;
    },
    onEdit(e) {
      this.editSelectediBankAccount = e;
      this.$refs.editibankaccount.$refs.editiBankAccount.show();
    },
    afterEditiBankAccount: function(item) {
      this.getiBankAccList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_ibank_account"), this.$t("message.success"), "success");
    },
    getOperatorList: function(isSearch) {
      this.pageLvl = 'opr';

      let url = config.accountListUrl();

      if (isSearch) this.currentOprPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentOprPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.search_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalOprRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setOperatorAccId: function (item) {
      this.currOperator = item;
      this.search = "";
      this.getiBankAccList();
    },
    getiBankAccList: function() {
      let url = config.ibankAccountListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.currOperator.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = 'bankAcc';
                this.ibankAccountList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changediBankAccStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_ibank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmiBankAccStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.own_status;
            item.own_status = !item.own_status;
          }
        });
    },
    confirmiBankAccStatus: function(item, status) {
      let url = config.ibankAccountStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.currOperator.account_id,
        bank_id: item.bank_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.own_status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedOprPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentOprPage = 1;
      this.getOperatorList(true);
    },
    changedOprPage: function(pageNo) {
      this.currentOprPage = pageNo;
      this.getOperatorList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>